/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ line: NonNullable<unknown> }} Chat_Space_File_LineInputs */



/**
* | output |
* | --- |
* | "Starting at line {line}" |
*
* @param {Chat_Space_File_LineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_line = /** @type {((inputs: Chat_Space_File_LineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_LineInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ab Zeile ${i?.line}`)
	return /** @type {LocalizedString} */ (`Starting at line ${i?.line}`)
});